import { DatePicker, message, Space, Table, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { ReportReturn } from "../../types/reportReturn.type";
import { api } from "../../api/api";
import dayjs from "dayjs";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ReportReturns() {
  const [returns, setReturns] = useState<ReportReturn[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchReturns = async () => {
    setLoading(true);
    try {
      const response = await api.get("/user/report/returns", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });

      setReturns(response.data.returns);
      setTotal(response.data.total);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получения возвратов.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReturns();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Имя",
      dataIndex: "warehouseMgrName",
      key: "warehouseMgrName",
    },
    {
      title: "Продукция",
      dataIndex: "produceName",
      key: "produceName",
    },
    {
      title: "Количество",
      dataIndex: "quantity",
      key: "quantity",
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>Возвраты Алюминий</Title>
      <Space style={{ marginBottom: 16 }}>
        <RangePicker
          onChange={handleRangeChange}
          placeholder={["Начало", "Конец"]}
          format="DD.MM.YY"
          value={dateRange}
        />
      </Space>

      <Table
        loading={loading}
        columns={columns}
        dataSource={returns}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
        }}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
